import { LoadingStyle } from '@/imports-files/components/loading';
import LoaderGif from '/public/images/loader/gif_loader.gif';
import Image from 'next/image'
export function Loading(props)
{
    return(<>
          <div className={`Loader ${LoadingStyle.Loading}`}>
            <div className={`${LoadingStyle.Loading__WrapperDots}`}>
                <div className={`${LoadingStyle.Loading__Dots}`}></div>
                <div className={`${LoadingStyle.Loading__Dots}`}></div>
                <div className={`${LoadingStyle.Loading__Dots}`}></div>
                <div className={`${LoadingStyle.Loading__Dots}`}></div>
            </div>
        </div>
            </>
          )
}
